import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {NewsWidgetState} from "./models/news-widget.state";
import {NewsWidgetConfig} from "./news-widget.config";

export class NewsWidgetStore extends BaseMobxStore {
  static injectables = [NewsWidgetConfig, NewsWidgetState];
}

